import React from "react";
import { ImCart } from "react-icons/im";

export default function Market({ color = "#000", ...props }) {
  return (
    <ImCart 
      size={28} 
      color={color} 
      {...props}
    />
  );
}
